import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { StageBadge } from "@/components/StageBadge";
import DealDrawer from "@/components/DealDrawer";
import { fmtDay } from "@/lib/meta";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";

export default function BDTracker() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dealId, setDealId] = useState(null);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/deals", { params: { bucket: "bd" } }).then(({ data }) => setRows(data.items)).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <PageHeader title="BD Tracker" subtitle="Deals at LOI and beyond — the ones closest to signing." />
      <div className="px-8 py-6">
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
          {loading ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#0047FF]" /></div>
            : rows.length === 0 ? <div className="text-center py-16 text-gray-400 text-sm" data-testid="bd-empty">No deals at LOI+ yet.</div>
            : (
              <Table>
                <TableHeader><TableRow className="bg-gray-50">
                  <TableHead>Property</TableHead><TableHead>City</TableHead><TableHead>Stage</TableHead>
                  <TableHead>Model</TableHead><TableHead>Target beds</TableHead><TableHead>Go-live</TableHead><TableHead>Rep</TableHead>
                </TableRow></TableHeader>
                <TableBody>
                  {rows.map((d) => (
                    <TableRow key={d.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => { setDealId(d.id); setOpen(true); }} data-testid={`bd-row-${d.id}`}>
                      <TableCell className="font-medium">{d.property_name}</TableCell>
                      <TableCell>{d.property_city || "—"}</TableCell>
                      <TableCell><StageBadge stage={d.stage} /></TableCell>
                      <TableCell>{d.model || "—"}</TableCell>
                      <TableCell>{d.target_bed_count || "—"}</TableCell>
                      <TableCell>{d.target_go_live ? fmtDay(d.target_go_live) : "—"}</TableCell>
                      <TableCell>{d.rep_name || "—"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
        </div>
      </div>
      <DealDrawer dealId={dealId} open={open} onOpenChange={setOpen} onChanged={load} />
    </div>
  );
}
